'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'

import ButtonCartGroup from '@/components/common/ButtonCartGroup'
import CustomImage from '@/components/common/CustomImage'
import ProductInventory from '@/components/common/ProductInventory'
import ProductTags from '@/components/common/ProductTags'
import Currency from '@/components/ui/Currency'
import Icon from '@/components/ui/icon'
import ShowUnit from '@/components/ui/ShowUnit'
import { cn, loadImage, productPriceChange } from '@/lib/utils'
import { Product, ProductFullSearchData } from '@/types/product.type'
import { useEffect, useState } from 'react'
import Tooltips from '@/components/ui/Tooltips'

type ProductCardMobileProps = {
  product: ProductFullSearchData
}

export default function ProductCardMobile({ product }: ProductCardMobileProps) {
  const t = useTranslations('common')
  const [isDisabled, setIsDisabled] = useState(false)

  const checkProductTags = (tags: Product['product_tags'], tagIds: number[]) => {
    let hasBannedTag = false
    if (tags) {
      for (const tagId of tagIds) {
        if (tags?.some(tag => tag.product_tag_id === tagId)) {
          hasBannedTag = true
          break
        }
      }

    }
    return hasBannedTag
  }

  useEffect(() => {
    if (!product) return
    if (
      // product.product_tag_id === 18 || product.product_tag_id === 15 || 
      checkProductTags(product.product_tags, [18, 15])) {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }, [product])

  return (
    // <div className="border-b border-b-bordercolor pb-2 pt-[9px]">
    //   <div className="mb-1">
    //     <Link href={`/${product.slug}`} target="_blank" className="line-clamp-4 overflow-hidden text-ellipsis leading-5 text-base">
    //       {product.name}
    //     </Link>
    //     <div className="flex">
    //       <div className="pt-2 w-[40%]">
    //         <div className="relative">
    //           <Link href={`/${product.slug}`} target="_blank">
    //             <CustomImage
    //               src={loadImage('large', product.image_id)}
    //               fallbackSrc="/assets/images/no-image.png"
    //               alt={product.name}
    //               width={0}
    //               height={0}
    //               sizes="100vw"
    //               className={cn('max-w-[130px] w-[99%]')}
    //             />
    //           </Link>
    //           {product.product_tags.length > 0 && <ProductTags tags={product.product_tags} />}
    //           {product.price_change && (
    //             <span className="tag-discount !text-[11px]">
    //               {t('discount')} {Math.abs(product.price_change)}%
    //             </span>
    //           )}
    //         </div>
    //         <div className='flex gap-6 justify-center items-center mt-2'>
    //           {product?.sheetfile && (
    //             <div className="relative inline-flex items-center group cursor-pointer mt-2">
    //               <Link href={product?.sheetfile ?? '#'} target="_blank" aria-label={`${product?.sheetname} | Data Sheet`}>
    //                 <Icon icon="tgic icon-file-pdf" className="text-red-500 text-3xl" />
    //               </Link>
    //               <Tooltips placement="right" className='z-[99] font-normal' style="warning" message={`${product?.sheetname} | Data Sheet`} />
    //             </div>
    //           )}
    //           <div>{product.rohs && <Icon icon="tgic icon-rohs" className="text-green-500 text-4xl" />}</div>
    //         </div>

    //         {/* {product.sheetfile && (
    //           <div className="mt-4 text-[12.5px] flex">
    //             <Link href={product.sheetfile} className="text-primary flex gap-1 flex-wrap" target="_blank">
    //               <Icon icon="tgic icon-file-pdf" className="text-sm" />
    //               <span className="group-hover:underline">{product.sheetname}</span>
    //             </Link>
    //           </div>
    //         )} */}
    //       </div>
    //       <div className="w-[60%] p-2">
    //         <div className="text-gray-800 text-sm">{product.supplier.name}</div>
    //         <div className="mt-2 pb-1 text-sm">
    //           <Currency className="font-bold" currency={product.price} lang="vi" />/<ShowUnit unit={product.unit} />
    //         </div>
    //         <ProductInventory product={product} />
    //         <ButtonCartGroup
    //           prices={product.prices}
    //           className="mt-2 pt-1"
    //           buttonSize="xs"
    //           multiples={product.multiples}
    //           productId={product.id}
    //           product={product}
    //           minQuantity={product.minimum_order_quantity}
    //           isDisabled={isDisabled}
    //         />
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="bg-white p-2">
      <div className="mb-1">
        <Link href={`/${product.slug}`} target="_blank" className="line-clamp-4 overflow-hidden text-ellipsis leading-6 text-base font-bold">
          {product.name}
        </Link>

        <div className="float-left pt-2 w-[40%]">
          <div className="relative">
            <Link href={`/${product.slug}`} target="_blank">
              <CustomImage
                src={loadImage('large', product.image_id)}
                fallbackSrc="/assets/images/no-image.png"
                alt={product.name}
                width={0}
                height={0}
                sizes="100vw"
                className={cn('max-w-[130px] w-[99%]')}
              />
            </Link>
            {product?.product_tags?.length > 0 && <ProductTags tags={product.product_tags} />}
            {/* {product.price_change && (
              <span className="tag-discount !text-[11px]">
                {t('discount')} {Math.abs(product.price_change)}%
              </span>
            )} */}
            <div className='flex gap-6 justify-center items-center mt-2 mr-4'>
              {product?.sheetfile && (
                <div className="relative inline-flex items-center group cursor-pointer mt-2">
                  <Link href={product?.sheetfile ?? '#'} target="_blank" aria-label={`${product?.sheetname} | Data Sheet`}>
                    <Icon icon="tgic icon-file-pdf" className="text-red-500 text-3xl" />
                  </Link>
                  <Tooltips placement="right" className='z-[99] font-normal' style="warning" message={`${product?.sheetname} | Data Sheet`} />
                </div>
              )}
              <div>{product.rohs && <Icon icon="tgic icon-rohs" className="text-green-500 text-4xl" />}</div>
            </div>
          </div>
          {/* {product.sheetfile && (
            <div className="mt-4 text-[12.5px] flex">
              <Link href={product.sheetfile} className="text-primary flex gap-1 flex-wrap" target="_blank">
                <Icon icon="tgic icon-file-pdf" className="text-sm" />
                <span className="group-hover:underline">{product.sheetname}</span>
              </Link>
            </div>
          )} */}
        </div>
        <div className="w-[60%] float-left pt-2">
          <div className="text-gray-800 text-sm">{product.supplier.name}</div>
          <div className="mt-2 text-sm flex items-center">
            <Currency className="font-bold" currency={product.price} lang="vi" />/<ShowUnit unit={product.unit} />
            {product.price_change && <span className="bg-[#cc4419] text-white px-1 text-[11px] ml-3 rounded flex items-center">-{Math.abs(product.price_change)}%</span>}
          </div>
          {product.price_change && (
            <div className="text-xs text-gray-500 pb-1">
              <Currency currency={productPriceChange(product.price, product.price_change)} lang="vi" discount />/<ShowUnit unit={product.unit} />
            </div>
          )}
          <ProductInventory product={product} />
          <ButtonCartGroup
            prices={product.prices}
            className="mt-2 pt-1"
            buttonSize="xs"
            multiples={product.multiples}
            productId={product.id}
            product={product}
            minQuantity={product.minimum_order_quantity}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    </div>
  )
}
